<template>
  <div>
    <v-system-bar app height="50px" style="background-image: linear-gradient(to right, #ffffff, #ffffff, #03429e)">
      <div class="d-flex align-center" style="cursor: pointer" @click="gomanage()">
        <v-img src="@/assets/Meetlogo.svg" max-width="60px" class="app-bar-left"></v-img>
        <!-- <v-img src="@/assets/logo.png" max-width="60px" class="app-bar-left" v-if="!showMain"></v-img> -->
      </div>
      <v-spacer></v-spacer>
      <!-- <v-col v-if="loginuser" cols="1" md="1" sm="1" xs="1" class="d-flex align-center justify-center">
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-btn icon small color="white" v-bind="attrs" v-on="on" @click.stop="openCsatDialog()">
              <v-icon color="white">mdi-emoticon-outline</v-icon>
            </v-btn>
          </template>
          <span>{{ $t("upperpage.csatButton") }}</span>
        </v-tooltip>
      </v-col> -->
      <v-col cols="5" md="2" sm="3" xs="3" style="
          font-size: 12px;
          color: white;
          text-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
        " v-if="loginuser" v-show="shownoroom">
        <span>{{ $t("upperpage.Storage") }} </span>
        <v-progress-linear :value="used_storageaverage" color="green accent-4"></v-progress-linear>
        <span> {{ dataareaonebox.used_storage }} </span><span> in </span><span> {{ dataareaonebox.storage }}</span>
      </v-col>
      <v-col cols="2" md="1" sm="2" xs="2" lg="2">
        <v-menu offset-y v-if="loginuser">
          <template v-slot:activator="{ on, attrs }">
            <div v-bind="attrs" v-on="on" class="pt-2 pb-3">
              <v-list-item>
                <v-list-item-avatar>
                  <!-- <v-img size="46" :src="avatar" v-model="avatar" ></v-img> -->
                  <v-icon dark size="46"> mdi-account-circle </v-icon>
                </v-list-item-avatar>
                <v-list-item-content v-if="
                  $vuetify.breakpoint.lg ||
                  $vuetify.breakpoint.md ||
                  $vuetify.breakpoint.xl
                ">
                  <v-list-item-title style="
                      font-size: 12px;
                      color: white;
                      text-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
                    ">
                    {{ firstname }} {{ lastname }}</v-list-item-title>
                  <v-list-item-subtitle class="mt-2" style="
                      font-size: 12px;
                      color: white;
                      text-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
                    ">Description Profile</v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
            </div>
          </template>
          <v-list width="350px">
            <v-row no-gutters class="mt-2">
              <v-col cols="1" md="1" sm="1" xs="1"></v-col>
              <v-col cols="10" md="10" sm="10" xs="10">
                <v-row no-gutters>
                  <v-col cols="12" md="12" sm="12" xs="12">
                    <v-row no-gutters>
                      <v-col cols="3" md="3" sm="3" xs="3" align-self="center">
                        <v-avatar color="indigo" size="65">
                          <!-- <v-img size="46" :src="avatar" v-model="avatar" ></v-img> -->
                          <v-icon dark size="45"> mdi-account-circle </v-icon>
                        </v-avatar>
                      </v-col>
                      <v-col md="1"></v-col>
                      <v-col cols="8" md="8" sm="8" xs="8" align-self="center" align="left">
                        <span style="font-size: 16px; font-weight: bold; font-family: Kanit">{{ firstname }} {{ lastname
                          }}</span>
                        <!-- <div  class="mt-2">
                        <v-btn
                          text
                          class="p-0 m-0 no-uppercase"
                          height="0"
                          color="#0078D6"
                          min-width="0"
                          style="font-family: Kanit; font-size: 15px"
                          @click="opendialsetingprofile()"
                          >{{$t("upperpage.setingprofile") }}</v-btn>
                      </div> -->
                        <!-- <div v-if="role === 'host'">
                        <v-btn
                          text
                          class="p-0 m-0 no-uppercase"
                          height="0"
                          color="#0078D6"
                          min-width="0"
                          style="font-family: Kanit; font-size: 15px"
                          @click="voteSetting"
                          >{{$t("upperpage.vote") }}</v-btn>
                      </div> -->
                        <div>
                          <v-btn text class="p-0 m-0 no-uppercase" height="0" color="#0078D6" min-width="0"
                            @click="logout()" style="font-family: Kanit; font-size: 15px">{{ $t("loginpage.logout")
                            }}</v-btn>
                        </div>
                      </v-col>
                    </v-row>
                  </v-col>
                </v-row>
              </v-col>
              <v-col cols="1" md="1" sm="1" xs="1"></v-col>
            </v-row>
            <v-divider class="p-0 m-0 pb-2 mt-4"></v-divider>
            <v-row no-gutters>
              <v-col cols="1" md="1" sm="1" xs="1"></v-col>
              <v-col cols="10" md="10" sm="10" xs="10">
                <v-row no-gutters>
                  <v-col cols="12" md="12" sm="12" xs="12">
                    <v-row no-gutters>
                      <v-col cols="6" md="6" sm="6" xs="6" align-self="center" align="left">
                        <v-row no-gutters>
                          <v-col cols="3" md="2" sm="3" xs="3" align-self="center">
                            <!-- <v-img
                            src="@/assets/logoOne.png"
                            max-width="21px"
                            max-height="30px"
                          ></v-img> -->
                          </v-col>
                          <v-col cols="9" md="10" sm="9" xs="9" align-self="center">
                            <span style="
                                font-family: Sarabun;
                                font-size: 14px;
                                font-weight: 400;
                                color: #353535;
                              ">ONE MEET</span>
                          </v-col>
                        </v-row>
                      </v-col>
                      <v-col md="2"></v-col>
                      <v-col cols="6" md="4" sm="6" xs="6" class="text-right" @click="versiononecenf">
                        <span style="cursor: pointer">
                          {{ $t("loginpage.version") }}
                          <v-icon color="#00A4EA">mdi-information-outline</v-icon>
                        </span>
                        <!-- <v-btn
                          text
                          class="p-0 m-0 no-uppercase"
                          height="0"
                          min-width="0"
                          style="font-family: Sarabun; font-size: 14px;">เวอร์ชั่น
                          <v-icon color="#00A4EA" size="17" class="pl-1">mdi-information-outline</v-icon></v-btn> -->
                      </v-col>
                    </v-row>
                  </v-col>
                </v-row>
              </v-col>
              <!-- <v-col cols="1" md="1" sm="1" xs="1"></v-col> -->
            </v-row>
          </v-list>
        </v-menu>
      </v-col>
      <v-col cols="3" md="2" lg="1" sm="2" xs="1">
        <div class="">
          <v-menu offset-y>
            <template v-slot:activator="{ on, attrs }">
              <v-list-item-content style="cursor: pointer">
                <v-list-item-title v-bind="attrs" v-on="on" class="text-white">
                  <v-icon color="white" style="font-size: 1.25em">mdi-web</v-icon>
                  <span> {{ $t("default") == "th" ? "TH" : "EN" }}</span>
                </v-list-item-title>
              </v-list-item-content>
            </template>
            <v-list>
              <v-list-item @click="change_languae('th')">
                <v-img src="@/assets/th.jpg" max-width="18px" max-height="18px"></v-img>
                <span>ไทย</span>
              </v-list-item>
              <v-list-item @click="change_languae('en')">
                <v-img src="@/assets/en.png" max-width="16px" max-height="16px"></v-img>
                English
              </v-list-item>
            </v-list>
          </v-menu>
        </div>
      </v-col>
      <!-- <v-row v-if="!showuser">
          <v-col md="9" cols="9" sm="9" xs="9"></v-col>
          <v-col md="3" cols="3" sm="3" xs="3" class="pr-12">
            <v-btn block text color="#FCE4EC" class="ma-2" @click="gotomain">
              LOGIN
            </v-btn>
          </v-col>
        </v-row> -->
    </v-system-bar>
    <v-dialog v-model="showCsatDialog" max-width="480px">
      <v-card>
        <v-toolbar dense flat color="#0baabd" dark>
          <v-toolbar-title>{{ $t("upperpage.csatTitle") }}</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon @click="closeCsatDialog">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-toolbar>
        <v-card-text class="pa-6">
          <p class="mb-4 text-subtitle-1">
            {{ $t("upperpage.csatPrompt") }}
          </p>
          <v-checkbox v-model="suppressFor24h" :label="$t('upperpage.csatDoNotShow')" color="primary" hide-details />
        </v-card-text>
        <v-card-actions class="pa-6 pt-0">
          <v-spacer></v-spacer>
          <v-btn text color="grey darken-1" @click="handleCsatDecision(false)">
            {{ $t("upperpage.csatLater") }}
          </v-btn>
          <v-btn color="primary" class="csat-confirm-btn" dark @click="handleCsatDecision(true)">
            {{ $t("upperpage.csatYes") }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <setingprofile :show="dialogshow" @close="dialogshow = false" />
  </div>
</template>

<script>
import { mapActions, mapState } from "vuex";
import setingprofile from "../components/dialog/setingprofile.vue";
// import VoteSystem from "../components/dialog/voteSystem.vue";

export default {
  components: {
    setingprofile,
    // VoteSystem,
  },
  data() {
    return {
      user: [],
      userData: null,
      showuser: false,
      showMain: true,
      jwt: require("jsonwebtoken"),
      role: "",
      used_storageaverage: 0,
      firstname: "",
      lastname: "",
      dataonebox: "",
      dataareaonebox: "",
      dialogvote: false,
      dialogshow: false,
      loginuser: false,
      shownoroom: false,
      sharedtoken: "",
      user_id: "",
      avatar: null,
      showCsatDialog: false,
      hasCheckedCsatPrompt: false,
      suppressFor24h: false,
      wasCsatSuppressed: false
    };
  },
  created() {
    // console.log('lujj', localStorage.getItem("lang"))
    // this.lg =  localStorage.getItem("lang")
    if (localStorage.getItem("user-token") !== null) {
      this.loginuser = true;
      this.decodetoken();
      //  this.getSharedToken()
    } else {
      this.loginuser = false;
    }
    // var roleEncrypt = localStorage.getItem('role')
    // // console.log('role', roleEncrypt)
    // if (roleEncrypt !== null) {
    //   const decryptedText = this.CryptoJS.AES.decrypt(
    //     roleEncrypt,
    //     'One Conference'
    //   ).toString(this.CryptoJS.enc.Utf8)
    //   this.role = decryptedText
    // }
  },
  computed: {
    ...mapState("dialog", ["dataprofile"]),
    participantName() {
      const parts = [this.firstname, this.lastname].filter(Boolean);
      const name = parts.join(' ').trim();
      if (name) {
        return name;
      }
      if (this.userData && this.userData.user && this.userData.user.email) {
        return this.userData.user.email;
      }
      return '';
    },
    csatUrl() {
      if (!this.participantName) {
        return '';
      }
      const base = (process.env.VUE_APP_WEBRTC || '').replace(/\/$/, '');
      if (!base) {
        return '';
      }
      return `${base}/conference/csat/portal/${encodeURIComponent(this.participantName)}`;
    },
    csatSessionKey() {
      const id = this.user_id || 'guest';
      return `csat-dialog-session-${id}`;
    },
    csatSuppressionKey() {
      const id = this.user_id || 'guest';
      return `csat-dialog-suppress-${id}`;
    }
  },
  mounted() { },
  watch: {
    dataprofile(vale) {
      // console.log('aaa', vale)
      // this.decodejwttoken()
    },
    loginuser(val) {
      if (val) {
        // this.$nextTick(() => this.maybeOpenCsatDialog());
      }
    },
    participantName() {
      // this.$nextTick(() => this.maybeOpenCsatDialog());
    }
  },
  methods: {
    ...mapActions("dialog", [""]),
    goPage(link) {
      this.$router.push(link).catch(() => { });
    },
    versiononecenf() {
      this.$swal.fire({
        title: "Version",
        text: `One Meeting Release version ${process.env.VUE_APP_VERSION_NUMBER} on ${process.env.VUE_APP_VERSION_DATE}`,
        icon: "info",
        showCancelButton: false,
        confirmButtonText: this.$t("button.btnok"),
        allowOutsideClick: false,
      });
    },
    openCsatDialog(manual = true, initialSuppression = null) {
      if (!this.csatUrl) {
        return;
      }
      const suppressed =
        initialSuppression === null ? this.isCsatSuppressed() : initialSuppression;
      this.wasCsatSuppressed = suppressed;
      this.suppressFor24h = manual ? suppressed : false;
      this.showCsatDialog = true;
    },
    closeCsatDialog() {
      this.handleCsatDecision(false);
    },
    handleCsatDecision(shouldRedirect) {
      const redirectUrl = shouldRedirect ? this.csatUrl : '';
      if (this.suppressFor24h) {
        this.setCsatSuppression();
      } else if (this.wasCsatSuppressed) {
        this.clearCsatSuppression();
      }
      this.showCsatDialog = false;
      this.suppressFor24h = false;
      this.wasCsatSuppressed = false;
      if (shouldRedirect && redirectUrl) {
        window.location.href = redirectUrl;
      }
    },
    maybeOpenCsatDialog() {
      if (!this.loginuser || !this.participantName || !this.user_id || !this.csatUrl) {
        return;
      }
      if (this.hasCheckedCsatPrompt) {
        return;
      }
      this.hasCheckedCsatPrompt = true;
      const suppressed = this.isCsatSuppressed();
      if (suppressed) {
        return;
      }
      if (typeof window === 'undefined' || !window.sessionStorage) {
        this.openCsatDialog(false, suppressed);
        return;
      }
      try {
        if (!window.sessionStorage.getItem(this.csatSessionKey)) {
          window.sessionStorage.setItem(this.csatSessionKey, 'true');
          this.openCsatDialog(false, suppressed);
        }
      } catch (error) {
        this.openCsatDialog(false, suppressed);
      }
    },
    isCsatSuppressed() {
      if (typeof window === 'undefined' || !window.localStorage) {
        return false;
      }
      const suppressKey = this.csatSuppressionKey;
      if (!suppressKey) {
        return false;
      }
      try {
        const raw = window.localStorage.getItem(suppressKey);
        if (!raw) {
          return false;
        }
        const expiresAt = parseInt(raw, 10);
        if (!Number.isFinite(expiresAt)) {
          window.localStorage.removeItem(suppressKey);
          return false;
        }
        if (Date.now() < expiresAt) {
          return true;
        }
        window.localStorage.removeItem(suppressKey);
        return false;
      } catch (error) {
        return false;
      }
    },
    setCsatSuppression() {
      if (typeof window === 'undefined' || !window.localStorage) {
        return;
      }
      const suppressKey = this.csatSuppressionKey;
      if (!suppressKey) {
        return;
      }
      try {
        const expiresAt = Date.now() + 24 * 60 * 60 * 1000;
        window.localStorage.setItem(suppressKey, String(expiresAt));
      } catch (error) {
        // ignore quota/security errors
      }
    },
    clearCsatSuppression() {
      if (typeof window === 'undefined' || !window.localStorage) {
        return;
      }
      const suppressKey = this.csatSuppressionKey;
      if (!suppressKey) {
        return;
      }
      try {
        window.localStorage.removeItem(suppressKey);
      } catch (error) {
        // ignore quota/security errors
      }
    },
    getonebox() {
      this.axios
        .post(process.env.VUE_APP_API + "/api/v1/onebox/getoneboxdata")
        .then((res) => {
          if (res.data.result === "Success") {
            this.shownoroom = true;
            this.dataonebox = res.data.data[0];
            this.areaonebox(this.dataonebox);
          } else {
            this.shownoroom = false;
            // console.log('Dataonebox :', res.data.message)
          }
        });
    },
    getprofile() {
      this.axios
        .get(process.env.VUE_APP_API + "/api/v1/theme/get/" + this.user_id)
        .then((res) => {
          // console.log('res', res)
          // this.avatar = res.data.data.user.profile
          this.avatar = res.data.data.user.profile;
          // console.log('user_profile', this.avatar)
        })
        .catch((err) => {
          console.log("err getprofile", err);
        });
    },
    opendialsetingprofile() {
      this.dialogshow = true;
    },
    async getSharedToken() {
      await this.axios
        .get(process.env.VUE_APP_ONEID + "/api/v2/service/shared-token")
        .then((res) => {
          // console.log('res', res.data)
          if (res.data.result === "Success") {
            this.sharedtoken = res.data.data.shared_token;
          } else {
            this.$swal.fire({
              title: res.data.message,
              text: "",
              icon: "warning",
              showCancelButton: false,
              confirmButtonText: this.$t("button.btnok"),
              allowOutsideClick: false,
            });
          }
        })
        .catch((err) => {
          this.$swal.fire({
            title: err.data.message,
            text: "",
            icon: "warning",
            showCancelButton: false,
            confirmButtonText: this.$t("button.btnok"),
            allowOutsideClick: false,
          });
        });
    },
    change_languae(language) {
      // console.log(language);
      if (language === "th") {
        localStorage.setItem("lang", "th");
        this.$i18n.locale = "th";
      } else if (language === "en") {
        localStorage.setItem("lang", "en");
        this.$i18n.locale = "en";
      }
    },
    voteSetting() {
      window.open(
        process.env.VUE_APP_API_SPACEVOTE +
        "/login-admin?shared-token=" +
        this.sharedtoken,
        "_blank"
      );
    },
    areaonebox(data) {
      this.axios
        .post(process.env.VUE_APP_API + "/api/v1/onebox/area", {
          account_id: data.account_id,
        })
        .then((res) => {
          if (res.data.result === "Success") {
            this.dataareaonebox = res.data.data;
            this.used_storageaverage =
              (this.dataareaonebox.used_storage.slice(0, 4) /
                this.dataareaonebox.storage.slice(0, 4)) *
              100;
          } else {
            this.dataareaonebox = "";
            // console.log('areaonebox :', res.data.message)
          }
        })
        .catch((err) => {
          console.log("areaonebox :", err);
        });
    },
    logout() {
      this.axios
        .delete(process.env.VUE_APP_API + "/api/lv1/auth/logout")
        .then((res) => {
          if (res.status === 200) {
            this.$swal
              .fire({
                title: this.$t("loginpage.logout"),
                text: this.$t("loginpage.Successfully"),
                icon: "success",
                showCancelButton: false,
                confirmButtonText: this.$t("button.btnok"),
                allowOutsideClick: false,
              })
              .then((result) => {
                localStorage.clear();
                localStorage.setItem("lang", "th");
                window.location.href = "/";
              });
          } else {
            console.log("ERRORlogout", res.data.message);
          }
        })
        .catch((e) => {
          localStorage.clear();
          localStorage.setItem("lang", "th");
          window.location.href = "/";
          console.log("ERRORlogout: ", e.result);
        });
    },
    gomanage() {
      if (
        localStorage.getItem("user-token") === null ||
        localStorage.getItem("user-token") === ""
      ) {
        window.open("/", "_self");
      } else {
        window.open("/manage", "_self");
      }
    },
    decodetoken() {
      var token = localStorage.getItem("user-token");
      const decryptedText = this.CryptoJS.AES.decrypt(
        token,
        process.env.VUE_APP_SECRET_KEY
      )
        .toString(this.CryptoJS.enc.Utf8)
        .replace(/"/g, "");
      var data = this.jwt.decode(decryptedText);
      // console.log('aaaa', data.user._id)
      this.user_id = data.user._id;
      this.userData = data;
      if (this.userData.user.room !== null) {
        this.role = "host";
      } else {
        this.role = "guest";
      }
      this.avatar = this.userData.user.avatar_profile;
      if (data.user.lastname === "") {
        this.firstname = data.user.email;
        this.lastname = "";
      } else {
        this.firstname = data.user.name;
        this.lastname = data.user.lastname;
      }
      // this.getonebox();
      // this.getprofile()
      // this.maybeOpenCsatDialog();
    },
  },
};
</script>

<style scoped>
.no-uppercase {
  text-transform: none;
}
.csat-confirm-btn {
  background-color: #0baabd !important;
}
</style>
